import React from 'react';
import linkedin from '../../src/app/images/common/linkedin.png';


class Footer extends React.Component {

    footerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        backgroundColor: "rgba(0,0,0,0.5)",
        border: "5px solid black",
        fontSize: "16px"
    };

    left = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "47.5%",
    }

    middle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "5%"
    }

    right = {
        display: "flex",
        alignItems: "left",
        textAlign: "center",
        justifyContent: "center",
        width: "47.5%",
    }

    image = {
        width: "40px",
        height: "40px"
    }
    
    render() {
        return (
        <div style={this.footerStyle}>
            <div style={this.left}>
                <h1>Ben Sander</h1>
            </div>
            <div style={this.middle}>
                <a href="https://www.linkedin.com/in/ben-sander-5a4a1b195" target="_blank" rel="noopener noreferrer"><img src={linkedin} style={this.image} alt="Linked In" /></a>
            </div>
            <div style={this.right}>
                Cheney, WA<br />bsander118@outlook.com
            </div>
        </div>
        );
    }
}

export default Footer;
